/**
 * 매칭 알고리즘 설정 (/adm/match-config)
 * ($j.Pages.Admin.MatchConfig / body data-page-name="MatchConfig")
 *
 * 세 덩어리를 한 화면에서 다룬다.
 *   ① 발송 배분 — 당일외 오더를 어느 (dt, ver) 로 매칭할지의 비율 + 최근 30일 실적
 *   ② 알고리즘 탭 — dt 별 세대 목록. 설명 문구 편집 + 세대 파라미터 폼 + 단계표 열람
 *   ③ 변경 이력
 *
 * 렌더는 전부 여기서 한다(Blade 는 셸만). 저장 후에는 화면을 다시 불러 서버 값과 맞춘다.
 */
import Util from '../../Common/Util';
export default class MatchConfig {
    initialize() {
        this.data = null;
        this.activeTab = 'NC';

        $('#mcSplitSave').on('click', () => this._saveSplit());

        // 탭 전환
        $('#mcTabs').on('click', 'a', (e) => {
            e.preventDefault();
            this.activeTab = $(e.currentTarget).data('dt');
            this._renderTabs();
        });

        // 세대 파라미터 저장 / 설명 저장
        // (단계표는 $j.Ui.Tooltip 팝오버 — data-tip-html 위임이라 여기서 따로 묶지 않는다)
        $('#mcTabBody')
            .on('click', '.mc-set-save',  (e) => this._saveSettings($(e.currentTarget).closest('.mc-ver')))
            .on('click', '.mc-type-save', (e) => this._saveType($(e.currentTarget).closest('.mc-ver')))
            // 등급방식이 점수순위면 등급 수 입력은 의미가 없다
            .on('change', '.mc-f[name="grade_mode"]', (e) => this._syncGradeSteps($(e.currentTarget).closest('.mc-ver')));

        this._load();
    }

    async _load() {
        try {
            const res = await $.ajax({url: '/adm/ajax/match-config/data', type: 'get', dataType: 'json'});
            if (!res.ok) return;
            this.data = res;
            this._renderSplit();
            this._renderTabs();
            this._renderLogs();
        } catch (e) {
            console.error('매칭설정 로드 실패', e);
            Util.swalert('설정을 불러오지 못했습니다.');
        }
    }

    // ─────────────────────────────────────────────── ① 발송 배분

    _renderSplit() {
        const rows = this.data.split;
        const total = rows.reduce((s, r) => s + (parseInt(r.weight) || 0), 0);
        const actualTotal = rows.reduce((s, r) => s + (parseInt(r.actual) || 0), 0)
                          + this.data.others.reduce((s, r) => s + (parseInt(r.actual) || 0), 0);

        const tr = rows.map(r => {
            const w = parseInt(r.weight) || 0;
            const pct = total > 0 ? Math.round(w / total * 100) : 0;
            const act = parseInt(r.actual) || 0;
            const actPct = actualTotal > 0 ? Math.round(act / actualTotal * 100) : 0;
            return `<tr>
                <td><b>${r.dt}</b> <span class="text-muted">ver${r.ver}</span></td>
                <td>${this._esc(r.label)}</td>
                <td class="text-center">
                    <input type="number" class="form-control form-control-sm mc-weight text-center"
                           style="width:80px;margin:0 auto" min="0" max="99"
                           data-dt="${r.dt}" data-ver="${r.ver}" value="${w}">
                </td>
                <td class="text-center">${w > 0 ? pct + '%' : '<span class="text-muted">미사용</span>'}</td>
                <td class="text-center">${act.toLocaleString()}건 <span class="text-muted">(${actPct}%)</span></td>
            </tr>`;
        }).join('');

        const others = this.data.others.map(r => `<tr class="text-muted">
                <td><b>${r.dt}</b> <span>ver${r.ver}</span></td>
                <td colspan="3">배분 대상 아님 (과거 매칭분)</td>
                <td class="text-center">${(parseInt(r.actual) || 0).toLocaleString()}건</td>
            </tr>`).join('');

        $('#mcSplit').html(`
            <table class="table table-bordered display" style="width:100%;">
                <thead>
                    <tr>
                        <th style="width:130px">알고리즘</th>
                        <th>설명</th>
                        <th style="width:110px" class="text-center">비율</th>
                        <th style="width:90px"  class="text-center">환산</th>
                        <th style="width:160px" class="text-center">최근 30일 실적</th>
                    </tr>
                </thead>
                <tbody>${tr}${others}</tbody>
            </table>
            <div class="mt-2" id="mcSplitHint"></div>
        `);

        $('#mcSplit').on('input', '.mc-weight', () => this._renderSplitHint());
        this._renderSplitHint();
    }

    /** 현재 입력값으로 만들어질 발송 주기를 문장으로 미리 보여준다 */
    _renderSplitHint() {
        const items = this._readSplit().filter(r => r.weight > 0);
        const total = items.reduce((s, r) => s + r.weight, 0);
        if (!total) {
            $('#mcSplitHint').html('<span class="text-danger">최소 하나는 1 이상이어야 합니다.</span>');
            return;
        }
        const seq = items.map(r => `${r.dt}(v${r.ver}) ${r.weight}`).join(' : ');
        $('#mcSplitHint').html(
            `<span class="text-muted">주기 <b>${total}건</b> 마다 &nbsp;${this._esc(seq)}&nbsp; 로 배정됩니다.</span>`
        );
    }

    _readSplit() {
        return $('#mcSplit .mc-weight').map((i, el) => ({
            dt: $(el).data('dt'),
            ver: parseInt($(el).data('ver')),
            weight: parseInt($(el).val()) || 0,
        })).get();
    }

    async _saveSplit() {
        const items = this._readSplit();
        const res = await this._post('/adm/ajax/match-config/split', {items});
        if (!res) return;
        Util.swalert(res.message, () => this._load());
    }

    // ─────────────────────────────────────────────── ② 알고리즘 탭

    _renderTabs() {
        const tabs = this.data.types.map(t =>
            `<li>
                <a class="${t.dt === this.activeTab ? 'active' : ''}" href="#" data-dt="${t.dt}">
                    ${this._esc(t.label)} <span class="ms-dt">${t.dt}</span>
                </a>
             </li>`
        ).join('');
        $('#mcTabs').html(tabs);

        const type = this.data.types.find(t => t.dt === this.activeTab);
        if (!type || !type.vers.length) {
            $('#mcTabBody').html('<div class="text-muted p-3">등록된 세대가 없습니다.</div>');
            return;
        }
        $('#mcTabBody').html(type.vers.map(v => this._verCard(type.dt, v)).join(''));
        type.vers.forEach(v => this._syncGradeSteps($(`.mc-ver[data-dt="${type.dt}"][data-ver="${v.ver}"]`)));
    }

    _verCard(dt, v) {
        const inUse = this.data.split.some(s => s.dt === dt && s.ver === v.ver && parseInt(s.weight) > 0);
        const tplId = `mcLvTpl-${dt}-${v.ver}`; // 단계표 팝오버 내용의 id (세대마다 다름)

        return `<div class="card card-outline ${inUse ? 'card-primary' : ''} mc-ver" data-dt="${dt}" data-ver="${v.ver}">
            <div class="card-header">
                <h3 class="card-title">
                    ver${v.ver}
                    ${inUse ? '<span class="badge badge-primary ml-1">사용중</span>'
                            : '<span class="badge badge-secondary ml-1">미사용</span>'}
                </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool mc-lv-btn"
                            data-tip-html="#${tplId}" data-tip-title="${dt} ver${v.ver} 단계표" data-tip-place="bottom">
                        <i class="fas fa-list-ol"></i> 단계표 ${v.levels.length}행
                    </button>
                </div>
            </div>
            <div class="card-body">
                ${this._typeForm(v)}
                ${v.settings ? this._settingsForm(v.settings) : ''}
            </div>
            <!-- 단계표 팝오버 내용 ($j.Ui.Tooltip 이 innerHTML 을 가져간다) -->
            <div id="${tplId}" style="display:none">${this._levelTable(v.levels)}</div>
        </div>`;
    }

    /** 회원 화면 도움말에 나가는 문구 */
    _typeForm(v) {
        return `
        <div class="form-group">
            <label class="mb-1">표시 이름</label>
            <input type="text" class="form-control form-control-sm mc-t" name="label" value="${this._esc(v.label)}">
        </div>
        <div class="form-group">
            <label class="mb-1">개요 <span class="text-muted">(회원 도움말 상단)</span></label>
            <textarea class="form-control form-control-sm mc-t" name="summary" rows="3">${this._esc(v.summary)}</textarea>
        </div>
        <div class="form-group">
            <label class="mb-1">발송 순서 <span class="text-muted">(한 줄 요약)</span></label>
            <input type="text" class="form-control form-control-sm mc-t" name="send_order" value="${this._esc(v.send_order)}">
        </div>
        <div class="text-right mb-3">
            <button type="button" class="btn btn-outline-secondary btn-sm mc-type-save">설명 저장</button>
        </div>`;
    }

    /**
     * 세대 파라미터 (현재는 -6차 포인트 세대만).
     *
     * 개념이 어려운 항목(특히 select)은 라벨 옆 물음표를 누르면 $j.Ui.Tooltip 팝오버가 뜬다.
     * 설명 원문은 Blade 의 숨은 템플릿(#tipXxx) — data-tip-html 이 그 innerHTML 을 가져온다.
     */
    _settingsForm(s) {
        // tip: Blade 템플릿 id ('#' 없이). 넘기면 라벨 옆에 도움말 아이콘이 붙는다.
        const help = (tip, title) => tip
            ? ` <i class="fas fa-question-circle mc-tip" data-tip-html="#${tip}" data-tip-title="${this._esc(title)}"></i>`
            : '';

        const num = (name, label, unit, hint, tip) => `
            <div class="form-group col-md-6">
                <label class="mb-1">${label}${help(tip, label)}</label>
                <div class="input-group input-group-sm">
                    <input type="number" class="form-control mc-f" name="${name}" value="${s[name]}">
                    ${unit ? `<div class="input-group-append"><span class="input-group-text">${unit}</span></div>` : ''}
                </div>
                ${hint ? `<small class="text-muted">${hint}</small>` : ''}
            </div>`;

        const sel = (name, label, hint, tip) => {
            const opts = Object.entries(this.data.enums[name] || {})
                .map(([k, v]) => `<option value="${k}" ${s[name] === k ? 'selected' : ''}>${this._esc(v)}</option>`).join('');
            return `<div class="form-group col-md-6">
                <label class="mb-1">${label}${help(tip, label)}</label>
                <select class="form-control form-control-sm mc-f" name="${name}">${opts}</select>
                ${hint ? `<small class="text-muted">${hint}</small>` : ''}
            </div>`;
        };

        return `
        <hr>
        <h6 class="mb-2"><i class="fas fa-bolt res-i is-msix"></i> -6차 적립</h6>
        <div class="form-row">
            ${num('accrue_rate', '적립률', '%', '장비대금 대비', 'tipAccrueRate')}
            ${sel('cap_mode', '적립 상한', '1건이 쌓을 수 있는 최대', 'tipCapMode')}
        </div>

        <h6 class="mb-2 mt-2"><i class="fas fa-hourglass-half"></i> 감쇠 · 만료</h6>
        <div class="form-row">
            ${num('decay_rate', '일일 감쇠율', '%', '0 이면 감쇠 없음 · 기존 -6차에도 소급', 'tipDecayRate')}
            ${num('expire_days', '만료 일수', '일', '넘기면 발주개수 1개로 전환', 'tipExpireDays')}
        </div>

        <h6 class="mb-2 mt-2"><i class="fas fa-sort-amount-down"></i> 차감 · 등급</h6>
        <div class="form-row">
            ${sel('deduct_mode', '수주 시 차감', '어느 -6차를 뺄지', 'tipDeductMode')}
            ${sel('grade_mode', '등급 기준', '-6차끼리의 우선순위', 'tipGradeMode')}
            ${num('grade_steps', '등급 수', '단계', '점수순위 방식이면 미사용', 'tipGradeSteps')}
        </div>

        <div class="text-right">
            <button type="button" class="btn btn-primary btn-sm mc-set-save">설정 저장</button>
        </div>`;
    }

    _levelTable(levels) {
        if (!levels.length) {
            return `<div class="text-muted mt-2">단계표가 없습니다. (등급 수가 매 오더마다 달라지는 방식)</div>`;
        }
        // 이 표는 팝오버 안에 들어간다. 좌표(odr1~odr5)는 내부 값이라 노출하지 않는다.
        const tr = levels.map(l =>
            `<tr>
                <td class="text-center">${l.lvl}</td>
                <td>${this._esc(l.memo || '')}</td>
             </tr>`
        ).join('');
        return `<div class="mc-lv-scroll">
            <table class="table table-bordered table-sm mb-0 mc-lv-table">
                <thead><tr>
                    <th style="width:52px" class="text-center">단계</th>
                    <th>설명</th>
                </tr></thead>
                <tbody>${tr}</tbody>
            </table>
        </div>`;
    }

    /** 점수순위 방식이면 등급 수 입력을 잠근다 */
    _syncGradeSteps($card) {
        if (!$card.length) return;
        const isRank = $card.find('.mc-f[name="grade_mode"]').val() === 'rank';
        $card.find('.mc-f[name="grade_steps"]').prop('disabled', isRank);
    }

    async _saveSettings($card) {
        const settings = {};
        $card.find('.mc-f').each((i, el) => { settings[$(el).attr('name')] = $(el).val(); });

        const res = await this._post('/adm/ajax/match-config/settings', {
            dt: $card.data('dt'), ver: $card.data('ver'), settings,
        });
        if (!res) return;

        let msg = res.message;
        if (res.needReseed) {
            msg += '\n\n등급 수가 바뀌어 단계표를 다시 만들어야 합니다.\n서버에서 match:describe 를 실행하세요.';
        }
        Util.swalert(msg, () => this._load());
    }

    async _saveType($card) {
        const body = {dt: $card.data('dt'), ver: $card.data('ver')};
        $card.find('.mc-t').each((i, el) => { body[$(el).attr('name')] = $(el).val(); });

        const res = await this._post('/adm/ajax/match-config/type', body);
        if (!res) return;
        Util.swalert(res.message, () => this._load());
    }

    // ─────────────────────────────────────────────── ③ 변경 이력

    _renderLogs() {
        const logs = this.data.logs || [];
        if (!logs.length) {
            $('#mcLogs').html('<div class="text-muted p-3">변경 이력이 없습니다.</div>');
            return;
        }
        const tr = logs.map(l => `<tr>
            <td class="text-center" style="white-space:nowrap">${this._esc(l.reg_date)}</td>
            <td class="text-center">${this._esc(l.admin_name)}</td>
            <td class="text-center">${l.scope === 'split' ? '발송 배분' : `${this._esc(l.dt)} ver${l.ver}`}</td>
            <td style="font-size:12px">${this._diff(l.before_val, l.after_val)}</td>
        </tr>`).join('');

        $('#mcLogs').html(`<table class="table table-bordered display mb-0" style="width:100%;">
            <thead><tr>
                <th style="width:150px" class="text-center">시각</th>
                <th style="width:100px" class="text-center">관리자</th>
                <th style="width:120px" class="text-center">대상</th>
                <th>변경</th>
            </tr></thead>
            <tbody>${tr}</tbody></table>`);
    }

    /** 바뀐 키만 뽑아 "키: 이전 → 이후" 로 */
    _diff(beforeJson, afterJson) {
        const a = this._parse(beforeJson), b = this._parse(afterJson);
        if (Array.isArray(a) || Array.isArray(b)) {
            return `<span class="text-muted">${this._esc(this._splitStr(a))}</span> → <b>${this._esc(this._splitStr(b))}</b>`;
        }
        const keys = Object.keys(b || {}).filter(k => String((a || {})[k]) !== String(b[k]));
        if (!keys.length) return '<span class="text-muted">변경 없음</span>';
        return keys.map(k => `${k}: <span class="text-muted">${this._esc((a || {})[k])}</span> → <b>${this._esc(b[k])}</b>`).join('<br>');
    }

    _splitStr(arr) {
        if (!Array.isArray(arr)) return '-';
        return arr.map(r => `${r.dt}(v${r.ver}) ${r.weight}`).join(' : ');
    }

    _parse(json) {
        try { return JSON.parse(json); } catch (e) { return null; }
    }

    // ─────────────────────────────────────────────── 공용

    async _post(url, body) {
        try {
            const res = await $.ajax({url, type: 'post', dataType: 'json', data: body});
            if (!res.ok) { Util.swalert(res.message || '저장에 실패했습니다.'); return null; }
            return res;
        } catch (e) {
            console.error('매칭설정 저장 실패', e);
            Util.swalert('저장 중 오류가 발생했습니다.');
            return null;
        }
    }

    _esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }
}
